import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M24 8H8v2.67h16V8Zm0 4H8v2.67h16V12ZM8 16v2.67h6.9V16H8Zm18.66 5.33H6.89L5.33 22.89V5.33h21.33v16H26.66v2.67c1.83 0 2.67-1.11 2.67-2.67 0-1.56 0-16 0-16C29.33 3.86 28.13 2.66 26.66 2.66H5.33C3.86 2.66 2.68 3.86 2.68 5.33v24L8 24h18.66v-2.67Z"
})), 'Chat', {
  viewBox: '0 0 16 16'
});